<script>
export default {
  name: 'SmartTable',
  props: {
    rowKey: [String, Function],
    columns: Array,
    apiPath: String,
    baseUrl: {
      type: String,
      default: ''
    },
    param: {
      type: Object,
      default () {
        return {}
      }
    },
    defaultParam: {
      type: Object,
      default () {
        return {}
      }
    },
    size: {
      type: String,
      default: 'small'
    },
    scroll: {
      type: Object,
      default () {
        return {}
      }
    },
    bordered: {
      type: Boolean,
      default: false
    },
    hasPage: {
      type: Boolean,
      default: true
    },
    locale: {
      type: Object
    }
  },
  data () {
    return {
      parameter: { pageNum: 1, pageSize: 20 },
      pagination: { pageNum: 1, pageSize: 20, showQuickJumper: false, showSizeChanger: true, hideOnSinglePage: true },
      loading: false,
      dataSource: [],
      selectedRowKeys: []
    }
  },
  watch: {
    param (newVal) {
      if (!newVal) return false
      const { parameter } = this
      this.parameter = {
        ...parameter,
        ...newVal
      }
    },
    parameter: {
      handler: 'fetch'
    }
  },
  methods: {
    fetch () {
      const { apiPath, defaultParam, parameter, baseUrl, hasPage, pagination } = this
      this.loading = true
      this.pagination = {
        ...pagination,
        current: parameter.pageNum
      }
      this.$http({
        baseURL: baseUrl,
        url: apiPath,
        method: 'POST',
        data: { ...defaultParam, ...parameter }
      }).then(res => {
        const { code, message, dataList, total, pageSize } = res
        if (code === 200 || code === '200') {
          // Read total count and page size from server
          this.pagination = hasPage && { ...this.pagination, total, pageSize }
          this.dataSource = dataList
          return false
        }
        this.$notification.error({ message })
      }).finally(() => {
        this.loading = false
      })
    },
    handleTableChange (pagination) {
      const parameter = { ...this.parameter }
      Object.assign(parameter, {
        pageNum: pagination.current,
        pageSize: pagination.pageSize
      })
      this.parameter = parameter
      this.pagination = pagination
    }
  },
  render () {
    const { loading, dataSource, pagination, size, rowKey, scroll, bordered, columns, locale } = this
    const props = { loading, dataSource, pagination, size, rowKey, scroll, bordered, columns, locale }
    return (
      <div class="smart-table">
        <a-table {...{ props, scopedSlots: { ...this.$scopedSlots } }} onChange={this.handleTableChange}>
          { Object.keys(this.$slots).map(name => (<template slot={name}>{this.$slots[name]}</template>)) }
        </a-table>
      </div>
    )
  }
}
</script>

<style lang="less" scoped>
  .smart-table /deep/
    .ant-table-small {
      .ant-table-content {
        .ant-table-body > table > .ant-table-thead {
          background-color: #F6F6F6;
          > tr > th {
            padding: 9px 8px;
            color: #555;
          }
        }
        .ant-table-body {
          margin: 0px;
          > table > .ant-table-tbody > tr > td {
            padding: 18px 8px;
          }
        }
        .ant-table-scroll,
        .ant-table-fixed-right{
          .ant-table-header {
            background: #fafafa;
            margin: 0;
            table > .ant-table-thead > tr > th {
              background-color: #fafafa;
              height: 45px;
            }
          }
          .ant-table-body > table > .ant-table-tbody > tr > td {
            padding: 9px 8px 8px;
          }

        }
      }
    }
  .smart-table-box {
    flex: 1;
    flex-grow: 1;
    overflow: hidden;
    height: 100%;
    .ant-table-wrapper {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: auto;
    }
    /deep/ .ant-table-pagination.ant-pagination {
      display: flex;
      justify-content: flex-end;
      padding-top:5px;
    }
    .ant-pagination {
      text-align: right;
    }
  }
</style>
